define('components/panel',[
    'jquery',
    './handlers/analytics'
], function($, analytics) {

    $.extend(companyInfo.handlers, {

        'toggle-panel': function(e) {
            var dataToggle = this.getAttribute('data-toggle');
            if (dataToggle === 'panel-with-info') {
                analytics(['read/show more', 'click ?', $(this).closest('h2').text()]);
            }
            $(this).closest('.panel').toggleClass(dataToggle);
            e.preventDefault();
        },

        'show-more': function(e) {
            var $this = $(this);
            var panelContent = $this.closest('.panel-content-constrained');
            var panel = panelContent.parent();

            var maxHeight = panelContent[0].scrollHeight + 30;
            panelContent.data('maxHeight', maxHeight);
            panelContent.addClass('panel-content-unconstrained').css({maxHeight: maxHeight}).removeAttr('data-decorator');
            setTimeout(function() {
                panelContent.css({maxHeight: 'none'});
            }, companyInfo.transitions);
            this.setAttribute('data-handler', 'show-less toggle-text toggle-icon');
            var top = panel[0].offsetTop;
            var prev = panel.prev();
            while (prev && prev[0] && prev[0].offsetTop == top) {
                $('[data-handler~="show-more"]', prev).click();
                prev = prev.prev();
            }
            var next = panel.next();
            while (next && next[0] && next[0].offsetTop == top) {
                $('[data-handler~="show-more"]', next).click();
                next = next.next();
            }

            if (!companyInfo.handlers['show-less']) {
                companyInfo.handlers['show-less'] = function(e) {
                    var $this = $(this);
                    var panelContent = $this.closest('.panel-content');
                    var panel = panelContent.parent();
                    var constrainCalc = !!panelContent.data('calcConstrain');
                    var calcMaxHeight = constrainCalc ? 
                        panelContent.find(".newsitem").eq(0).outerHeight() + 
                        panelContent.find(".newsitem").eq(1).outerHeight() + 80 : "";
                    var constrainHeight = calcMaxHeight || panelContent.data('constrain-height') || 400;
                    panelContent.removeClass('panel-content-unconstrained').css({maxHeight: panelContent.data('maxHeight')});
                    setTimeout(function() {
                        panelContent.attr('data-decorator', 'constrain-panel').css({maxHeight: constrainHeight});
                    }, 10);
                    this.setAttribute('data-handler', 'show-more toggle-text toggle-icon');

                    //animate to the top of the panel
                    var top = panel[0].offsetTop;
                    $('html, body').animate({
                        scrollTop: top
                    }, companyInfo.transitions);

                    var prev = panel.prev();
                    while (prev && prev[0] && prev[0].offsetTop == top) {
                        $('[data-handler~="show-less"]', prev).click();
                        prev = prev.prev();
                    }
                    var next = panel.next();
                    while (next && next[0] && next[0].offsetTop == top) {
                        $('[data-handler~="show-less"]', next).click();
                        next = next.next();
                    }

                    //require(['components/decorator'], function(decorator) {
                    //    decorator.run(panel);
                    //});
                };
            }

        },

        'show-all': function(e) {
            e.preventDefault();
            var url = this.href;
            var panel = $(this).closest('.panel');
            var targetSelector = this.getAttribute('data-target');
            var panelContent = panel.find(targetSelector);
            if (url.indexOf('?') === -1) {
                url = url + '?partial=true';
            } else {
                url = url + '&partial=true';
            }
            $.get(url).always(function(data) {
                data = data.responseText || data;
                var html = $('<div>').append($.parseHTML(data)).find(targetSelector + ' > *');
                if (!html.length) {
                    html = data;
                }
                panelContent.html(html);
                require(['components/decorator'], function(decorator) {
                    decorator.run(panelContent);
                });
            });
        }

    });

    $.extend(companyInfo.decorators, {

        'constrain-panel': function() {
            var panelContent = $(this);
            var panel = panelContent.parent();
            var scrollHeight = panelContent[0].scrollHeight;
            var button = panelContent.find('.show-more');
            var top = panel[0].offsetTop;
            var prev = panel.prev();
            var compareWith;
            var constrainCalc = !!panelContent.data('calcConstrain');
            var calcMaxHeight = constrainCalc ? 
                panelContent.find(".newsitem").eq(0).outerHeight() + 
                panelContent.find(".newsitem").eq(1).outerHeight() + 80 : "";
            var maxHeight = calcMaxHeight || panelContent.data('constrain-height') || 400;

            if (prev[0] && prev[0].offsetTop == top) {
                compareWith = prev;
            } else {
                var next = panel.next();
                if (next[0] && next[0].offsetTop == top) {
                    compareWith = next;
                }
            }
            if (compareWith) {
                compareWith = $('.panel-content', compareWith);
                var decorator = compareWith[0].getAttribute('data-decorator');
                if (!decorator || decorator.indexOf('constrain-panel') === -1) {
                    maxHeight = Math.max(compareWith[0].scrollHeight, maxHeight);
                }
            }

            if ( scrollHeight <= maxHeight + 100 ) {
                return false;
            }

            if (!button.length ) {
                var showMoreButton = $('<p class="show-more no-print"><button data-handler="show-more toggle-text toggle-icon" data-toggle-text="' + companyInfo.labels.showLess + '" data-toggle-icon="ico ico-caret-up"><i class="ico ico-caret-down"></i><span>' + companyInfo.labels.showMore + '</span></button></p>');
                panelContent.addClass('panel-content-constrained').css({maxHeight: maxHeight}).prepend(showMoreButton);
                // TODO: add something so the showMore button doesn't move out of view (this happens when you search on the page or tab through a constrained panel)
            } else {
                panelContent.addClass('panel-content-constrained').css({maxHeight: maxHeight});
            }

            if (panelContent.data('was-open')) {
              panelContent.addClass('notransition');
              panelContent.find('.show-more button').trigger('click');
              panelContent.removeClass('notransition');
            }

            return true;
        },
        'constrain-sub-panel': function() {
            var container = $(this);
            var constrainHeight = container.data('constrain-height') && parseInt(container.data('constrain-height'), 10);
            var maxHeight = constrainHeight || 200;
            var ANIMATION_DURATION = 300;
            var height = container.outerHeight();
            var isExpanded = false;

            container.addClass('sub-panel'); // Adding styles to enable showing/hiding of content.

            if (height > maxHeight) {
                container.css('height', maxHeight);
                addExpandButton(container);


                container.find('.sub-panel__expand-button-label').on('click', function () {
                    var label = $(this);
                    var expanderSection = label.parent();
                    var caret = expanderSection.children().first();
                    var expanderHeight = expanderSection.outerHeight(); // Adding expander height so it fits when we expand

                    if (!isExpanded) {
                        container.animate({ height: height + expanderHeight}, ANIMATION_DURATION);
                        caret.removeClass('ico-caret-down').addClass('ico-caret-up');
                        label.text(companyInfo.labels.showLess);
                        expanderSection.removeClass('sub-panel__expand-button--shadow');
                        isExpanded = true;
                    } else {
                        container.animate({ height: maxHeight }, ANIMATION_DURATION);
                        caret.removeClass('ico-caret-up').addClass('ico-caret-down');
                        label.text(companyInfo.labels.showMore);
                        expanderSection.addClass('sub-panel__expand-button--shadow');
                        isExpanded = false;
                    }
                });
            }

            function addExpandButton(container) {
                var icon = isExpanded ? 'up' : 'down';
                var label = isExpanded ? companyInfo.labels.showLess : companyInfo.labels.showMore;
                var shadow = isExpanded ? '' : 'sub-panel__expand-button--shadow';
                var expandButton = '<div class="sub-panel__expand-button ' + shadow + '">' +
                        '<span class="ico ico-caret-' + icon + '"></span>' +
                        " " +
                        '<span class="sub-panel__expand-button-label">' + label + '</span>' +
                    '</div>';
                container.append(expandButton);
            }
        }

    });

});

